import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: '/kahve1.png',
      title: 'Kaliteli Karton Bardak Üretimi',
      subtitle: 'Bulut Ambalaj ile işletmeniz için en kaliteli karton bardak çözümlerini sunuyoruz.'
    },
    {
      image: '/kahve2.png',
      title: 'Çevre Dostu Ürünler',
      subtitle: 'Sürdürülebilir ve çevre dostu ambalaj çözümleri ile geleceğe değer katıyoruz.'
    },
    {
      image: '/kahve3.png',
      title: 'Özel Tasarım Seçenekleri',
      subtitle: 'Markanıza özel tasarım ve baskı seçenekleriyle fark yaratın.'
    },
    {
      image: '/kahve4.png',
      title: 'Hızlı Teslimat',
      subtitle: 'Geniş üretim kapasitemiz ile hızlı ve güvenilir teslimat garantisi.'
    },
    {
      image: '/pizzavepida.png',
      title: 'Pizza Kutusu, Pide Kutusu ve Koli Üretimi',
      subtitle: 'Pizza kutusu, pide kutusu ve isteğe göre koli üretimi ile geniş ürün yelpazemiz.'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="hero-overlay"></div>
            <div className="hero-content">
              <div className="hero-text">
                <h1 className="hero-title">{slide.title}</h1>
                <p className="hero-subtitle">{slide.subtitle}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="hero-arrow hero-arrow-left" onClick={goToPrevious} aria-label="Önceki">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      <button className="hero-arrow hero-arrow-right" onClick={goToNext} aria-label="Sonraki">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      <div className="hero-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`hero-dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
